/* eslint-disable require-yield */
/* eslint-disable no-unused-vars */
import { all, takeEvery, put, call, takeLatest, select } from 'redux-saga/effects'
import {
  deleteFile,
  loadCategories,
  loadFiles,
  downloadFile,
  updateFile,
  loadFileById,
  syncEmail,
} from 'services/files'
import { notification } from 'antd'
import _ from 'lodash'

import actions from './actions'
import getFiles from './selectors'

/** ********************************************
 *
 * @abstract DELETE_FILE
 * @param {*} param0
 *
 * ****************************************** */
export function* DELETE_FILE({ payload }) {
  const { id, name } = payload
  try {
    const { file, totalSize, count } = yield call(deleteFile, id)
    if (file) {
      // we send a update to redux store
      const files = yield select(getFiles)
      yield put({
        type: 'files/FILE_DELETED',
        payload: {
          // eslint-disable-next-line no-underscore-dangle
          files: files.filter(doc => doc._id !== file._id),
          totalSize,
          refreshIndex: true,
          count,
        },
      })

      // We send the notification to the user
      notification.success({
        message: `${name} deleted successfully !`,
      })
    }
  } catch (error) {
    const message = error.response
      ? error.response.data.message
      : `Error, ${name} could not be deleted`
    notification.error({
      message,
      description: 'Please try again !',
    })
  }
}

/** ********************************************
 *
 * @abstract SEARCH_FILE
 * @param {*} param0
 *
 * ****************************************** */
export function* SEARCH_FILE({ payload }) {
  const { results, query } = payload
  console.log('query length', query.length)
  if (query === '') {
    console.log('query is empty')
    yield put({
      type: 'files/UPDATE_RESULTS',
      payload: {
        results: yield select(getFiles),
      },
    })
  }
  if (query.length >= 2) {
    console.log('query', query)
    yield put({
      type: 'files/UPDATE_RESULTS',
      payload: {
        results: results.map(file => file.item),
      },
    })
  }
}

/** ********************************************
 *
 * @abstract LOAD_FILES
 * @param {*} param0
 *
 * ****************************************** */
export function* LOAD_FILES({ payload }) {
  const { page, limit, category } = payload
  // display loader
  yield put({
    type: 'files/LOADING_STATUS',
    payload: {
      loading: true,
    },
  })

  const results = yield call(loadFiles, page, limit, category)
  const { files, maxSize, totalSize, count, previous, next, current, pageSize } = results

  if (files) {
    yield put({
      type: 'files/LOAD_ALL_FILES',
      payload: {
        files,
        maxSize,
        totalSize,
        count,
        previous,
        next,
        current,
        limit: pageSize,
      },
    })
  }
  // Hide loader
  yield put({
    type: 'files/LOADING_STATUS',
    payload: {
      loading: false,
    },
  })
}

/** ********************************************
 *
 * @abstract LOAD_FILE
 * @param {*} param0
 *
 * ****************************************** */
export function* LOAD_FILE({ payload }) {
  const { id } = payload
  if (id) {
    const file = yield call(loadFileById, id)
    if (file) {
      yield put({
        type: 'files/LOAD_FILE_BY_ID',
        payload: {
          file,
        },
      })
    }
  }
}

/** ********************************************
 *
 * @abstract UPLOAD_FILE
 * @param {*} param0
 *
 * ****************************************** */
export function* UPLOAD_FILE({ payload }) {
  const { status, file, count, totalSize } = payload
  console.log('file before reducer update', file)
  if (status === 'done') {
    yield put({
      type: 'files/UPLOADED_FILE',
      payload: {
        file,
        count,
        totalSize,
      },
    })
    notification.success({
      message: `Image successfully updated`,
      description: `Image name: ${file.name}`,
    })
  }
}

/** *********************************************
 *
 * @abstract DOWNLOAD FILE
 * @param {*} param0
 *
 * ********************************************* */
export function* DOWNLOAD_FILE({ payload }) {
  const { name } = payload
  notification.warning({
    message: `Please wait for the download`,
    description: `File name: ${name}`,
  })
  yield call(downloadFile, name)
}

/** *********************************************
 * @abstract UPDATE_FILE
 * @param {*} param0
 *
 * ********************************************* */
export function* UPDATE_FILE({ payload }) {
  const { file } = payload
  const { dbFile } = yield call(updateFile, file)

  // we should check the dbFile !null
  // we should call yield put to update the state
  if (!_.isNull(dbFile) && !_.isUndefined(dbFile)) {
    yield put({
      type: 'files/UPDATE_FILE_REDUCER',
      payload: {
        file,
      },
    })
  }
}

export function* ADD_CATEGORY({ payload }) {
  const { value, fileId } = payload
  const files = yield select(getFiles)
  // eslint-disable-next-line no-underscore-dangle
  const myfile = files.find(file => file._id === fileId)
  const category = [value, ...myfile.category]

  yield put({
    type: 'files/UPDATE_CATEGORY',
    payload: {
      category,
      fileId,
    },
  })

  notification.success({
    message: `New category added`,
    description: `Value: ${value}`,
  })
}

export function* ADD_TAG({ payload }) {
  const { value, fileId } = payload
  const files = yield select(getFiles)
  // eslint-disable-next-line no-underscore-dangle
  const myfile = files.find(file => file._id === fileId)
  const tags = [value, ...myfile.tags]
  yield put({
    type: 'files/UPDATE_TAG',
    payload: {
      tags,
      fileId,
    },
  })
  notification.success({
    message: `New tag added`,
    description: `Value: ${value}`,
  })
}

/**
 * LOAD_CATEGORIES
 *
 */
export function* LOAD_CATEGORIES() {
  const categories = yield call(loadCategories)

  if (categories.length >= 1) {
    yield put({
      type: 'files/CATEGORIES',
      payload: {
        categories,
      },
    })
  }
}

export function* SYNC_EMAIL() {
  const value = yield call(syncEmail)
  // eslint-disable-next-line no-alert
  alert('sync Email')
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.ADD_CATEGORY, ADD_CATEGORY), // listen to add category action
    takeEvery(actions.ADD_TAG, ADD_TAG), // listen to add tog action
    takeEvery(actions.UPDATE_FILE, UPDATE_FILE),
    takeEvery(actions.DELETE_FILE, DELETE_FILE), // listen to deleting files
    takeEvery(actions.DOWNLOAD_FILE, DOWNLOAD_FILE), // listen to uploading files
    takeEvery(actions.SEARCH_FILE, SEARCH_FILE), // listen to search files
    takeLatest(actions.LOAD_FILES, LOAD_FILES), // listen to loading all files
    takeLatest(actions.LOAD_FILE, LOAD_FILE), // listen to loading all files
    takeLatest(actions.LOAD_CATEGORIES, LOAD_CATEGORIES), // listen to loading all categories
    takeLatest(actions.UPLOAD_FILE, UPLOAD_FILE), // listen to uploading files
    takeLatest(actions.SYNC_EMAIL, SYNC_EMAIL), // sync email for new attachement files
  ])
}
